import { css } from "@emotion/react";

import { useCompanyLevelContent } from "components/CompanyLevel/hooks";

import { CompanyLevelProps } from "../types";

const CompanyLevelRectangle = ({ companyLevelName }: CompanyLevelProps) => {
    const { companyLevelHeaderParams } = useCompanyLevelContent();

    return (
        <div
            css={css({
                backgroundColor:
                    companyLevelHeaderParams.backgroundColors[
                        companyLevelName as keyof typeof companyLevelHeaderParams.backgroundColors
                    ],
                width: "100%",
                borderRadius: "2px",
                height: "8px"
            })}
        />
    );
};

export default CompanyLevelRectangle;
